import { Action } from "src/state/_types";
import logger from 'src/utils/logger';

export const initializeApi: Action = async ({state,effects}) => {
    if(state.auth) {
        logger('Initializing GraphQL API')
        effects.gql.initialize({
            endpoint: import.meta.env.VITE_GQL_API_URL || '',
            headers: () => ({
                'Authorization': `Bearer ${state.auth.token}`
            })
        });
    }
}